module.exports = __webpack_public_path__ + "img/ee7034e.jpg";